import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalBody.vue?vue&type=template&id=331fa694&"
import script from "./AssessmentGlobalSingleTaskModalBody.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports